












































































































































































































import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import ChatSidebar from '@/components/Chat/ChatSidebar.vue'
import ChatInput from '@/components/Chat/ChatInput.vue'
import ChatMessages from '@/components/Chat/ChatMessages.vue'
import {Action, Getter, namespace} from 'vuex-class'
import {ChatMention, ChatMessage, ChatReply, ChatStatus, ChatTemplate, ChatWorkflow} from '@/entities/chat'
import {addNote, addReply, requestLock, runWorkflow} from '@/api/chat'
import Loading from '@/components/Loading.vue'
import ChatEditTemplate from '@/components/Chat/ChatEditTemplate.vue'
import {ConvUIQuestions} from '@/pages/dashboard/entities/dash'


declare let UIkit
@Component<Chat>({
    components: {ChatEditTemplate, Loading, ChatMessages, ChatInput, ChatSidebar}
})
export default class Chat extends Vue {
    @Prop(Function) public replyCallBack ?: (question) => {} // call back function when add reply
    @Prop(Boolean) public loadPublishTemplate

    public savingNote = false
    public savingReply = false
    public runningWorkflow = false
    public isSalesforce = false // todo
    public blocked = false // if chat is locked by another user
    public culprit = '' // who is blocking the chat
    public blockedReason = '' // reason the chat is blocked
    public timeout

    @Getter public chatMessages !: ChatMessage[]
    @Getter public chatStatus !: ChatStatus
    @Getter public chatCustomData
    @Getter public chatTemplates !: {[id: number]: ChatTemplate}
    @Getter public chatWorkflows
    @Getter public mentionUsers
    @Getter public tags
    @Getter public userPermissions !: string[]
    @Getter public activeQuestionId
    @Getter public caseOptions
    @Getter public loading
    @Getter public chatConvQuestions !: { [questionId: number]: ConvUIQuestions}
    @Getter
    hasNetworkConnection!:boolean

    @Action public loadChat
    @Action public loadTemplates
    @Action public loadWorkflows
    @Action public loadCaseOptions
    @Action public loadMentionUsers
    @Action public loadTags
    @Action public getUserPermissions
    @Action public setChatStatus
    @Action public loadConvQuestions
    @Action public loadVisibleOnPlan

    public get getChatMessages() {
        const updatedMessages = this.chatMessages
        if (
            updatedMessages.length > 0 &&
            updatedMessages[0].hasOwnProperty('conversational')
        ) {
            const keys = Object.keys(updatedMessages[0]['conversational'])
            for (const key of keys) {
                // use value from conversation param table in stead of event table
                // will drop conversationevent table in future.
                if (this.chatCustomData.hasOwnProperty(`${key}_c`)
                    && updatedMessages[0]['conversational'][key].input_type !== 'ReceiveText') {
                    // There's a problem with how we handle ReceiveText response data: it doesn't get stored as a param, just
                    // as a sentiment score in the questionparam table.  The actual data gets stored in the conversationevent
                    // table.  Therefore, if the input_type is ReceiveText, we shouldn't be overriding it.
                    // See receiveAnswer over in ConversationService.php for more.

                    if (Array.isArray(this.chatCustomData[`${key}_c`])) {
                        updatedMessages[0]['conversational'][key].value = this.chatCustomData[`${key}_c`][0]
                    } else {
                        updatedMessages[0]['conversational'][key].value = this.chatCustomData[`${key}_c`]
                    }
                }
            }
        }
        return updatedMessages
    }

    public get isUserBasic() {
        return this.userPermissions.includes('ROLE_USER_BASICS')
    }

    public get canAddNote() {
        return this.userPermissions.includes('ROLE_ADD_NOTES')
    }

    public get canDeleteNote() {
        return this.userPermissions.includes('ROLE_DELETE_NOTES')
    }

    public get canViewNameEmail() {
        return this.userPermissions.includes('ROLE_VIEW_NAME_AND_EMAIL')
    }

    public get canReplaceNameWithCustomField() {
        return this.userPermissions.includes('ROLE_REPLACE_CUSTOM_FIELD')
    }

    // can reply doesn't mean can click, (if don't contact set, then we disable button)
    public get canReply() {
        return this.isUserBasic && !this.isAnom
    }

    public get replyTooltip() {
        if (this.dontContact) {
            return 'This person does not wish to be contacted'
        } else if (this.isPhoneNumber) {
            return 'This person may not be able to reply to your SMS'
        } else {
            return ''
        }
    }

    public get isAnom() {
        return !!Number(this.chatCustomData.anom)
    }

    public get dontContact() {
        return !!Number(this.chatCustomData.dontcontact)
    }

    public get questionType() {
        return this.chatCustomData.question_type
    }

    public get isPhoneNumber() {
        return !!Number(this.chatCustomData.is_phone_number)
    }

    public get showWorkflow() {
        return !this.isAnom &&
            !this.dontContact &&
            this.isUserBasic &&
            !this.isSalesforce
    }

    public get person() {
        if (!this.chatCustomData || !this.chatCustomData.person ) {
            return  { id: '-1', name: '' }
        }
        if ((this.canViewNameEmail || this.canReplaceNameWithCustomField) && !this.isAnom) {
            return this.chatCustomData.person
        }
        return { id: '-1', name: 'Anon' }
    }

    public get responseCount() {
        return Number(this.chatCustomData.response_count)
    }

    public get email() {
        if (this.canViewNameEmail && !this.isAnom) {
            return this.chatCustomData &&
                this.chatCustomData.person &&
                this.chatCustomData.person.email || 'Deleted'
        }
        return ''
    }

    public get customFields() {
        return this.chatCustomData
    }

    // field names used by chat templates
    public get fields() {
        const fields = ['firstname', 'lastname', 'name', 'email', 'segment']
        return [...fields, ...Object.keys(this.chatCustomData)
            .filter((a) => /_c$/.test(a))
            .sort()
            .map((a) => (a.replace(/_c$/, '')))]
    }

    public get maxTextLength() {
        return this.email.includes('sms.asknice.ly') ? 321 : 0
    }

    public get hasUnpublishedReview() {
        let has = false
        this.chatMessages.forEach((message: any) => {
            if (message.type === 'review' &&
                Number(message.review_rating) &&
                !Number(message.review_replied)) {
                has = true
            }
        })

        return has
    }

    @Watch('chatCustomData')
    public onCustomDataChanged() {
        const newStatus = {
            ...this.chatStatus,
            reply_from: this.chatCustomData.from_name || '',
            reply_subject: this.chatCustomData.default_subject || '',
            email_reply: !!Number(this.chatCustomData.email_reply)
        }

        this.setChatStatus(newStatus)

        if (this.caseOptions.length === 0) {
            this.loadCaseOptions()
        }
    }

    public async mounted() {
        this.onActiveQuestionIdChange()
        await this.loadVisibleOnPlan()
    }

    public onEscapeKeyDown(event: KeyboardEvent) {
        if (this.chatStatus.editing && event.key === 'Escape') {
            event.stopImmediatePropagation()
            this.setChatEditing(0)
        }
    }

    public beforeDestroy() {
        clearTimeout(this.timeout)
    }

    // poll to see if chat is locked by another user
    public async poll(interval) {
        const id = this.activeQuestionId
        if (!document.hasFocus()) {  // only poll if we are in the foreground
            this.timeout = setTimeout(() => this.poll(0), 3000)
            return
        }

        this.timeout = setTimeout(async () => {
            try {
                if (!Number(this.activeQuestionId)) {
                    return
                }
                const {data} = await requestLock(this.activeQuestionId)
                this.onPollSuccess(data)
                // setup the next poll recursively
                this.poll(3000)
            } catch (e) {
                this.poll(30000)
            }
        }, interval)
    }

    public onPollSuccess(data) {
        if (data.status === 'failure') {
            this.blocked = true
            this.blockedReason = data.reason
            this.culprit = ''
            return
        }
        this.blockedReason = ''
        const lockedID = parseInt(data.user_id, 10)
        const myUserId = parseInt(this.chatCustomData.user_id, 10)
        if (myUserId !== lockedID) { // lock
            if (!this.blocked) {
                this.culprit = data.username
                if (!this.culprit) {
                    this.culprit = data.email
                }
            }
            this.blocked = true
        } else { // unlock
            this.blocked = false
        }
    }

    public setChatEditing(editing) {
        if (this.dontContact && editing === 1) {
            return
        }
        this.setChatStatus({...this.chatStatus, editing})
    }

    public onUpdateReplyFrom(e) {
        this.setChatStatus({...this.chatStatus, reply_from: e.target.value})
    }

    public onUpdateEmailReply(e) {
        this.setChatStatus({...this.chatStatus, email_reply: e.target.checked})
    }

    public onUpdateReplySubject(e) {
        this.setChatStatus({...this.chatStatus, reply_subject: e.target.value})
    }

    public onChatInput(text) {
        if (this.chatStatus.editing === 1) {
            // this.setChatStatus({note: this.chatStatus.note, reply: text, editing: 1})
            this.setChatStatus({...this.chatStatus, reply: text})
        } else if (this.chatStatus.editing === 2) {
            this.setChatStatus({...this.chatStatus, note: text})
            // this.setChatStatus({note: text, reply: this.chatStatus.reply, editing: 2})
        }
    }

    public onSelectTemplate(template: ChatTemplate) {
        this.setChatStatus({
            ...this.chatStatus,
            reply: template.text,
            editing: 1,
            reply_subject: template.subject
        })
        if (this.$refs.replyInput) {
            (this.$refs.replyInput as ChatInput).updateContent(template.text)
        }
    }

    public async onSelectWorkflow(workflow: ChatWorkflow) {
        if (this.runningWorkflow) {
            return
        }

        this.runningWorkflow = true
        const {data} = await runWorkflow(workflow.id, this.activeQuestionId, false)
        if (data.success !== true) {
            if (confirm(`${data.message}\nAre you sure you want to run "${data.name}"?`)) {
                await runWorkflow(workflow.id, this.activeQuestionId, true)
                await this.loadChat()
                this.notifyQuestionChanged()
            }
        } else {
            UIkit.notify('Workflow \'' + data.name + '\' has been scheduled to run!', {status: 'success'})
            await this.loadChat()
            this.notifyQuestionChanged()

        }
        this.runningWorkflow = false
    }

    public onChangeReplyReviewStatus(reply_reiview: boolean) {
        this.setChatStatus({...this.chatStatus, reply_review: reply_reiview, editing: 1})
    }

    // on edit/delete/new template
    public onTemplateUpdate(reloadTemplate) {
        this.setChatStatus({...this.chatStatus, editing_template: -1})
        if (reloadTemplate) {
            this.loadTemplates()
        }
    }

    public onUndoChat(message) {
        this.setChatStatus({...this.chatStatus, reply: message.message})
    }

    public get sendLabel() {
        return 'Send' + (this.chatCustomData.case_closed !== '0' ? '' : ' & Close Case')
    }

    @Watch('activeQuestionId')
    public async onActiveQuestionIdChange() {
        if (!this.userPermissions.length) {
            this.getUserPermissions()
        }

        if (!this.chatMessages.length) {
            await this.loadChat()
            this.scrollToBottom()
        }
        this.poll(0)

        if (!Object.keys(this.chatTemplates).length) {
            await this.loadTemplates()
        }

        if (!this.chatConvQuestions[this.activeQuestionId]
            || !Object.keys(this.chatConvQuestions[this.activeQuestionId]).length) {
            this.loadConvQuestions(this.activeQuestionId)
        }

        if (!Object.keys(this.chatWorkflows).length) {
            this.loadWorkflows()
        }

        if (!this.mentionUsers.length) {
            this.loadMentionUsers()
        }

        if (!this.tags.length) {
            this.loadTags()
        }

        if (this.loadPublishTemplate) {
            const publishTemplate = this.getPublishTemplate()
            if (publishTemplate !== null) {
                this.onSelectTemplate(publishTemplate)
            }
        }
    }

    public scrollToBottom() {
        if (this.$refs.chatMessages) {
            (this.$refs.chatMessages as any).scrollToBottom()
        }
    }

    public async saveNote() {
        if (this.savingNote) {
            return
        }
        this.savingNote = true

        // process mentions before save
        let note = this.processNoteMentions(this.chatStatus.note)
        note = note.replace(/(?:\s|^)#([^\]]\w+)\b/g, '[#$1](tag:$1)') // hash tag
        await addNote(this.activeQuestionId, note)
        this.setChatStatus({...this.chatStatus, note: '', editing: 0})
        this.savingNote = false
        await this.loadChat()
        this.scrollToBottom()
        this.notifyQuestionChanged()
    }

    public async saveReply(justSend) {
        if (this.savingReply || !this.chatStatus.reply) {
            return
        }
        this.savingReply = true

        // process mentions before save
        const reply = {
            emailreply: this.chatStatus.email_reply ? 'On' : 'Off',
            subject: this.chatStatus.reply_subject,
            from_name: this.chatStatus.reply_from,
            message: this.chatStatus.reply,
            publishReview: this.chatStatus.reply_review ? '1' : '0'
        } as ChatReply
        if (!justSend) {
            reply.closecase = 'true'
            reply.caseClosedOption = 'Asknicely'
        }
        const activeTemplateId = this.getActiveTemplate()
        if (activeTemplateId) {
            reply.template_id = activeTemplateId
        }
        await addReply(this.activeQuestionId, reply)

        this.setChatStatus({...this.chatStatus, reply: '', editing: 0})
        await this.loadChat()
        this.loadTemplates()
        this.savingReply = false
        this.scrollToBottom()

        this.notifyQuestionChanged()
    }

    public notifyQuestionChanged() {
        // let whoever is interested know that we are updated
        if (this.replyCallBack) {
            this.replyCallBack({
                ...this.chatCustomData,
                note_count: this.noteCount,
                workflow_count: this.workflowCount
            })
        }
    }

    public getPublishTemplate() {
        const publishTemplates = Object.values(this.chatTemplates).filter((el) => el.name === 'Publish')
        if (publishTemplates.length > 0) {
            return publishTemplates[0]
        }
        return null
    }

    public get noteCount() {
        return this.chatMessages.filter((msg) => msg.type === 'note').length
    }

    public get workflowCount() {
        return this.chatMessages.filter((msg) => msg.type === 'automation').length
    }

    public getActiveTemplate() {
        for (const id in this.chatTemplates) {
            if (this.chatTemplates.hasOwnProperty(id)) {
                const template = this.chatTemplates[id]
                if (template.subject === this.chatStatus.reply_subject &&
                    template.text === this.chatStatus.reply.replace(/^\n|\n$/g, '')) {
                    return id
                }
            }
        }
        return null
    }

    public processNoteMentions(text) {
        const users = new Map<string, string>()
        for (const user of this.mentionUsers) {
            if (user.name === null) {
                if (user.email === null) {
                    continue
                }
                user.name = user.email
            }
            if (user.name.trim() !== '') {
                users.set(user.name, user.email)
            }
        }
        users.forEach((email, name) => {
            const replace = `@${name}`
            const re = new RegExp(replace, 'g')
            text = text.replace(re, `[@${name}](user:${email})`)
        })
        return text
    }
}
